export default "__VITE_ASSET__DZY49odd__"